import React from "react"
import Dashboard from "./dashboard"

export default props => <Dashboard {...props} />
